// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderMessage_wrapper__0N8jk","content":"HeaderMessage_content__eYTaf","button":"HeaderMessage_button__RFAQv"};